import { render, staticRenderFns } from "./single.vue?vue&type=template&id=1ed3b1ee"
import script from "./single.vue?vue&type=script&lang=js"
export * from "./single.vue?vue&type=script&lang=js"
import style0 from "./single.vue?vue&type=style&index=0&id=1ed3b1ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports